import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { StyledMainBox } from "../../../../../components/commonComponents/StyledComponents/styled";
import { Close, Download } from "@mui/icons-material";
import CloseButton from "../../../../../components/commonComponents/Buttons/CloseButton";
import { fetchPictureUrl } from "../../../../../api_calls/pictureRequests";
import { toast } from "react-toastify";
import { checkUserDetailsFromCookie } from "../../../../../api_calls/userManagement";
import ActionButton from "../../../../../components/commonComponents/Buttons/ActionButton";

const ShowLoopContentPreview = ({ open, onClose, size, closeModal, loopInfo }) => {
  const [contentUrl, setPicUrl] = React.useState("");
  const userDetail = checkUserDetailsFromCookie();

  React.useEffect(() => {
    const rootCompanyId = userDetail.user_detail.root_company_id;
    /*
      update: 28 April 2025,
      loopInfo.picture_company_id replaced by rootCompanyId as asked by the backend.
    */
    fetchPictureUrl(loopInfo.id, rootCompanyId).then((info) => {
      if (info.success === true) {
        setPicUrl(info.pic_file_url);
      } else {
        toast("Sorry, picture can't be loaded.", { type: "error" });
        closeModal();
      }
    });
  }, []);
  return (
    <Dialog
      open={open}
      onClose={(e) => {
        e.preventDefault();
      }}
      fullWidth={true}
      maxWidth={size}
    >
      <DialogTitle>Preview: {loopInfo.content}</DialogTitle>
      <DialogContent>
        <StyledMainBox component="main">
          <Box sx={{ display: "flex" }}>
            {contentUrl !== "" && (
              <>
                {loopInfo.content.endsWith(".mp4") ? (
                  <video style={{ width: "100%", height: "auto" }} controls muted >
                    <source src={contentUrl} type="video/mp4" />
                  </video>
                ) : (
                  <img style={{ width: "100%", height: "auto" }} src={contentUrl} />
                )}
              </>
            )}
          </Box>
        </StyledMainBox>
      </DialogContent>
      <Box height={20} />
      <DialogActions>
        <Stack direction={"row"} spacing={2}>
          <CloseButton
            onClick={(e) => {
              e.preventDefault();
              closeModal();
            }}
            label="Cancel"
            icon={<Close />}
          />
          <a
            href={contentUrl}
            download={loopInfo.content}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: 'none',
              display: 'inline-flex',
              alignSelf: 'end'
            }}

          >
            <ActionButton
              label={"Download"}
              icon={<Download />}
              sx={{ margin: 0 }}
            />
          </a>
        </Stack>
      </DialogActions>
    </Dialog >
  );
};

export default ShowLoopContentPreview;
